import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import { LeftNavLayout } from 'containers';
export default function PublishingWrapper(props) {
  var sidebarItems = [{
    link: "/org/".concat(props.organization.id, "/publishing/schedule"),
    linkText: 'Schedule'
  }, {
    link: "/org/".concat(props.organization.id, "/publishing/draft-posts"),
    linkText: 'Draft Posts'
  }, {
    link: "/org/".concat(props.organization.id, "/publishing/queues"),
    linkText: 'Queues'
  }];
  var appLayoutInnerStyle = props.innerLayoutStyle || {
    display: 'flex',
    flex: '1 1 auto',
    padding: 0,
    overflow: 'auto',
    height: '100%'
  };
  var wrapStyle = {
    flex: '1 1 auto',
    padding: 0
  };
  var pageTitle = "".concat(props.organization.name).concat(props.organization.name.split('').pop() === 's' ? "'" : "'s", " Settings");
  return /*#__PURE__*/React.createElement(LeftNavLayout, {
    sidebar: true,
    rightPanel: props.rightPanel,
    sidebarItems: sidebarItems,
    params: _objectSpread({}, props.params),
    wrapStyle: wrapStyle,
    appLayoutInnerStyle: appLayoutInnerStyle
  }, props.children);
}